export default "__VITE_ASSET__BY0qGTl6__"